export default "__VITE_ASSET__DftDZAvF__"